const labels = {
  All: { 'See the offering': '查看服務' },
  FacilityDetails: { 'Ref: Page title': '設施詳情', 'Ref: Review': '查看' },
  FacilitiesList: { 'Ref: Page title': '設施', 'Ref: See details': '查看詳情' },
};
export default labels;
